import Main from "_c/main"

export default {
    path: "/",
    name: "",
    component: Main,
    children: [
        {
            path: "/customers",
            name: "customers",
            component: () => import('@/view/customers'),
            meta:{
                parent:true,
                parentName:"customers",
                name:"客户",
                assess:true
            },
            children: [
                {
                    path: "ment",
                    name: "ment",
                    component: () => import("@/view/customers/ment"),
                    meta:{
                        parent:false,
                        parentName:"customers",
                        name:"客户管理",
                        assess:true
                    }
                },
            ]
        }
    ]

}


// WEBPACK FOOTER //
// ./src/router/modules/customers.js